import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import WhyItHelps from "@/components/sections/WhyItHelps";
import Stats from "@/components/sections/Stats";
import MarketGrowth from "@/components/sections/MarketGrowth";
import HowItWorks from "@/components/sections/HowItWorks";
import BookDemo from "@/components/sections/BookDemo";
import Contact from "@/components/sections/Contact";
import QrCode from "@/components/sections/QrCode";
import Footer from "@/components/sections/Footer";
import PrivacyPolicy from "@/components/pages/PrivacyPolicy";
import TermsOfUse from "@/components/pages/TermsOfUse";

export const DEMO_LINK = "https://app.reclaim.ai/m/orderhalal-demo/ai-demo";

const Home = () => (
  <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
    <div className="App grain bg-ink text-cream selection:bg-terra">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <MarketGrowth />
        <WhyItHelps />
        <Stats />
        <HowItWorks />
        <BookDemo />
        <Contact />
      </main>
      <QrCode />
      <Footer />
    </div>
  </ReactLenis>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
